
const messages = {
  error: 'No se pudo cancelar la suscripción, por favor intenta más tarde',
}

export default messages
